import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import api from '@/lib/api';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { loginWithSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    (async () => {
      try {
        const res = await api.post('/auth/session', { session_id: sessionId });
        const { user, session_token } = res.data;
        loginWithSession(user, session_token);
        // Clean URL and navigate
        window.history.replaceState(null, '', '/app');
        navigate('/app', { replace: true, state: { user } });
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/login');
      }
    })();
  }, [navigate, loginWithSession]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-[#1E4E8C] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
